/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import { Label, Table } from 'reactstrap';
import { Button } from 'react-bootstrap';
import CenterSpinner from '../../components/CenterSpinner';
import '../../assets/style/SetTargets.css';
import { TextField } from '@mui/material';
import {
  clearTargetList,
  fetchTargetList,
  targetSelector,
} from '../../features/setTargetSlice';
import {
  FilterType,
  LoggedUserType,
  MapOptionType,
  SelectOptionType,
  TargetType,
  UserType,
} from '../../utils/Types';
import {
  DEFAULT_OPTION_LOCATION_SET_TARGET,
  TARGET_FILTER_INIT,
} from '../../utils/Constant';
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import { loginSelector } from '../../features/loginSlice';
import ToggleSwitch from '../../components/ToggleSwitch';
import {
  formatNumber,
  getCurrentFinancialYear,
  getPreviousFinancialYear,
  getTargetPayload,
  handleAllIndiaData,
  handlePostTargetList,
  handleTitleClick,
  onCurrentTargetChanged,
} from './SetTargetHelper';
import { locationFilterSelector } from '../../features/locationFilterSlice';
import SetTargetFilterNew from '../../filters/SetTargetFilterNew';
import { STATE_ACCESS_ROLES, ZONE_ACCESS_ROLES } from '../../utils/RBAC';
const SetTargetsPage = () => {
  const [targetState, setTargetState] = useState<{
    label: string;
    value: string | number | null;
  }>();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedFiltersData, setSelectedFiltersData] =
    useState<FilterType>(TARGET_FILTER_INIT);

  const dispatch = useAppDispatch();
  const [globalData, setGlobalData] = useState<TargetType[]>([]);
  const [targetData, setTargetData] = useState<TargetType[]>([]);
  const [targetUpdateData, setTargetUpdateData] = useState<any>(undefined);
  const [tableFilters, setTableFilters] =
    useState<FilterType>(TARGET_FILTER_INIT);
  const [disableField, setDisableField] = useState<boolean>(false);
  const user: LoggedUserType = useAppSelector(loginSelector).user;
  const userDetails: UserType = useAppSelector(loginSelector).userDetails;
  const [showFilter, setShowFilter] = useState<boolean>(true);
  const yearOptions: SelectOptionType[] =
    useAppSelector(targetSelector).yearOptions;
  const targetDataResponse: TargetType[] =
    useAppSelector(targetSelector).targetListData.result;
  const minTargetCount =
    useAppSelector(targetSelector).targetListData.minTargetCount;

  const allStates: MapOptionType = useAppSelector(
    locationFilterSelector
  ).statesData;
  const zoneOptionRaw: SelectOptionType[] = useAppSelector(
    locationFilterSelector
  ).zoneOptions;
  const zoneOption =
    zoneOptionRaw && zoneOptionRaw.length > 1
      ? [DEFAULT_OPTION_LOCATION_SET_TARGET, ...zoneOptionRaw]
      : zoneOptionRaw;

  const getTargetList = (filteredValues?: any) => {
    const payload = getTargetPayload(
      selectedFiltersData,
      filteredValues,
      setTableFilters,
      TARGET_FILTER_INIT
    );
    setLoading(true);
    dispatch(fetchTargetList(payload));
  };

  const onApply = (activeDrop: any) => {
    getTargetList();
    setTargetState(activeDrop);
  };

  useEffect(() => {
    setTargetData(targetDataResponse);
    setGlobalData(targetDataResponse);
    setLoading(false);
  }, [targetDataResponse]);
  useEffect(() => {
    if (
      (ZONE_ACCESS_ROLES.includes(user?.roleId) &&
        targetState?.value === 'All') ||
      (STATE_ACCESS_ROLES.includes(user?.roleId) &&
        targetState?.label === 'Zone')
    ) {
      setDisableField(true);
    } else {
      setDisableField(false);
    }
  }, [user, userDetails, targetState]);

  useEffect(() => {
    dispatch(clearTargetList());
  }, []);

  const handleToggleSwitch = () => {
    setShowFilter((prev) => !prev);
  };
  function formatToIndianNumberSystem(value: number | string): string {
    if (typeof value === 'string') {
      value = Number(value);
    }
    if (isNaN(value)) {
      return '-'; // Handle cases where value is not a number
    }
    return new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(
      value
    );
  }

  const onReset = () => {
    setTargetData([]);
    setGlobalData([]);
    setTargetUpdateData(undefined);
  };
  useEffect(() => {
    if (zoneOption && zoneOption.length === 1) {
      const stateArray = allStates[zoneOption[0].value];
      setSelectedFiltersData({
        ...selectedFiltersData,
        zone: zoneOption[0].value,
        state:
          stateArray.length === 1
            ? stateArray[0].value
            : DEFAULT_OPTION_LOCATION_SET_TARGET.value,
      });
    }
  }, [zoneOption]);
  const tableHeaders = targetData?.[0]?.targets || [];
  return (
    <div>
      <Label className="text-heading"> Set Targets</Label>
      <ToggleSwitch isOpen={showFilter} onClick={handleToggleSwitch} />
      <div className="task-item-parent-view">
        {showFilter && (
          <SetTargetFilterNew
            onApply={onApply}
            selectedFiltersData={selectedFiltersData}
            setSelectedFiltersData={setSelectedFiltersData}
            tableFilters={tableFilters}
            onReset={onReset}
          />
        )}
        <div className="container-parent">
          {targetData?.length ? (
            <div>
              <div className="inner-div">
                <div className="d-flex justify-content-between align-items-center">
                  <p className="target-inner-header">Target Allocation</p>
                  <div className="d-flex flex-column align-items-end">
                    <span className="active-emp target-sub-value">
                      Previous year target (
                      {getPreviousFinancialYear(
                        selectedFiltersData,
                        yearOptions
                      )}
                      ): {formatNumber('prev', globalData)}
                    </span>
                    <span className="active-emp ">
                      Current year target (
                      {getCurrentFinancialYear(
                        selectedFiltersData,
                        yearOptions
                      )}
                      ): {formatNumber('current', globalData)}
                    </span>
                  </div>
                </div>
                <hr />
                <div className="target-table">
                  <Table striped hover responsive style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th className="text-start table-header-wrapper target-table-width">
                          {targetState?.label ?? 'Zone'}:{' '}
                          {targetState?.value ?? 'All'}
                        </th>
                        <th className="ttext-start table-header-wrapper target-table-width">
                          Employee Name
                        </th>
                        {tableHeaders?.map((targetHead: any) => (
                          <th key={targetHead?.productId}>
                            <div className="table-header-wrapper d-flex flex-column align-items-end">
                              <span>{targetHead?.productName} Target</span>
                              <span>Achieved</span>
                            </div>
                          </th>
                        ))}
                        {tableHeaders?.map((targetHead: any) => (
                          <th
                            key={targetHead?.productId}
                            className="table-header-wrapper"
                          >
                            <div className="d-flex flex-column align-items-end">
                              <span>Prem.Target for</span>
                              <span>{targetHead?.productName} (INR)</span>
                            </div>
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {targetData?.map((item: any, index: any) => (
                        <tr key={item?.grid + index}>
                          <th className="target-names cursor-pointer target-td">
                            <td
                              className="button-container"
                              onClick={() => {
                                if (
                                  selectedFiltersData?.grid === 'All' ||
                                  !selectedFiltersData.grid ||
                                  (Array.isArray(selectedFiltersData.grid) &&
                                    selectedFiltersData.grid.length > 1)
                                )
                                  handleTitleClick(
                                    selectedFiltersData,
                                    setTargetState,
                                    setTableFilters,
                                    getTargetList,
                                    item
                                  );
                              }}
                            >
                              {handleAllIndiaData(item)}
                              {Array.isArray(selectedFiltersData.grid) &&
                              selectedFiltersData.grid.length &&
                              Array.isArray(selectedFiltersData.village) &&
                              selectedFiltersData.village.length > 1 &&
                              item?.gridId
                                ? ` ${item?.cityName ?? ''}${item?.mandalName ? ' - ' + item.mandalName : ''}`
                                : null}
                            </td>
                          </th>
                          <td className="target-td">
                            {item?.reportingManager || '-'}
                          </td>
                          {item?.targets?.map((target: any) => (
                            <td
                              key={target?.productId}
                              className="text-end target-td"
                            >
                              {target?.targetValuePreviousYear ?? '-'}
                            </td>
                          ))}
                          {item?.targets?.map(
                            (target: any, targetIndex: number) => (
                              <td key={target?.targetIndex}>
                                <div
                                  key={target?.targetIndex}
                                  className="d-flex justify-content-end"
                                >
                                  <TextField
                                    id="outlined-basic"
                                    variant="outlined"
                                    className="current-year input-td-wrapper"
                                    size="small"
                                    value={
                                      target?.targetValueCurrentYear
                                        ? formatToIndianNumberSystem(
                                            target.targetValueCurrentYear
                                          )
                                        : '-'
                                    }
                                    disabled={
                                      disableField || !target?.isEditable
                                    }
                                    onChange={(e) => {
                                      onCurrentTargetChanged(
                                        e,
                                        index,
                                        targetData,
                                        targetUpdateData,
                                        globalData,
                                        targetIndex,
                                        {
                                          setTargetData,
                                          setTargetUpdateData,
                                        }
                                      );
                                    }}
                                  />
                                </div>
                              </td>
                            )
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-4 pt-1">
                <Button
                  aria-label="Set Target"
                  variant="primary"
                  className="cl-btn-primary pt-1 pb-1"
                  onClick={() => {
                    handlePostTargetList(
                      targetUpdateData,
                      targetData,
                      minTargetCount,
                      {
                        setLoading,
                        getTargetList,
                        setGlobalData,
                        setTargetUpdateData,
                      },
                      toast,
                      dispatch
                    );
                  }}
                  disabled={
                    !targetUpdateData ||
                    Object.keys(targetUpdateData).length === 0
                  }
                >
                  Set Target
                </Button>
                <Button
                  variant="outline-primary"
                  className="mx-2 cl-btn-outline-primary"
                  onClick={() => {
                    setTargetData(globalData);
                    setTargetUpdateData(undefined);
                  }}
                >
                  Cancel
                </Button>
              </div>
            </div>
          ) : (
            <div className="d-flex justify-content-center data-not-found table-parent-onboarding">
              <Label className="data-not-found-label">Data not found</Label>
            </div>
          )}
        </div>
      </div>
      <CenterSpinner showLoader={loading} />
    </div>
  );
};

export default SetTargetsPage;
